<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="picker mResult">
      <van-field :label="field.options.label" :required="field.options.required" clickable v-model="fieldModel"
        :readonly="field.options.readonly" :disabled="field.options.disabled" :placeholder="field.options.placeholder"
        :input-align="field.options.textAlign" @input="handleChangeEvent" @blur="handleInputCustomBlur" />

    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import { isNull } from "@/utils/util";

export default {
  name: "fieldWidget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  inject: ["refList", "globalOptionData", "globalModel"],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedValue: "",
      fieldModel: "",
      rules: [],
    };
  },
  components: {
    FormItemWrapper,
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initFieldModel();
    this.initEventHandler();
    this.buildFieldRules();

    this.handleOnCreated();
  },

  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    handleInputCustomEvent1(value) {
      this.fieldModel = value
      this.handleInputCustomEvent(value);

      let tmpFunc = new Function("value", this.field.options.onChange);
      return tmpFunc.call(this, this.getValue());
    },
    handleInputCustomBlur() {
      this.handleBlurCustomEvent(this.fieldModel);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/vant.scss";

.area-input {
  height: 36px;
  border: 1px solid #ccc;
  padding-left: 10px;
}


.close {
  text-align: center;
  border-top: 1px solid #DCDFE6;
}
</style>
